import { Link, NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 sticky-top my-header-bg z-5">
        <div className="container py-2">
          <div className="d-flex align-items-center">
            <Link to="/">
              <img
                src="/assets/images/logo.png"
                className="d-lg-none d-block"
                width="100"
              />
              <img
                src="/assets/images/logo.png"
                width="120"
                className="me-5 d-lg-block d-none"
              />
            </Link>
          </div>
          <div className="ms-auto d-flex align-items-center order-lg-3">
            <div>
              <div className="d-flex align-items-center">
                <div class="d-flex gap-2 align-items-center justify-content-end me-lg-5 d-none d-md-block">
                  <a href="#" target="_blank">
                    <i className="bi bi-facebook text-dark fs-4 me-3"></i>
                  </a>
                  <a href="#" target="_blank">
                    <i className="bi bi-instagram text-dark fs-4 me-3"></i>
                  </a>
                  <a href="#" target="_blank">
                    <i className="bi bi-twitter-x text-dark fs-4 me-3"></i>
                  </a>
                </div>
                <Link
                  to="/login"
                  className="text-red-primary fs-4 fw-medium rounded-pill px-4"
                >
                  Login
                </Link>
                <a
                  href="https://play.google.com/store/apps/details?id=com.gorishteyapp&hl=en_SG"
                  target="_blank"
                  className="btn bg-red-primary text-white fw-normal rounded-pill px-5 ms-1"
                >
                  Download App
                </a>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-default">
            <ul className="navbar-nav  mt-3 mt-lg-0 ms-4">
              <li className="nav-item">
                <NavLink to="/" className="nav-link ps-0">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link">
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/terms" className="nav-link">
                  Terms & Conditions
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Header;
